module.exports = __webpack_public_path__ + "static/media/meritus-1.f9cf7123.jpg";